/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  font-size: ${scale.major(2)}px;
  font-weight: bold;
  height: ${scale.major(8)}px;
  justify-content: center;
  width: 100%;
`;
